import React, { useContext, Fragment } from "react";
import "../../../ui-styles/conference/confResNav.css";
import "../../../ui-styles/conference/confResNavList.css";
import { LangCtx, localRecordingCtx } from "../../../lib/context";

const ConfResNav = (props) => {
    console.log("prps are res nav........", props);
    const { l } = useContext(LangCtx);
    const record = useContext(localRecordingCtx);

    return (
        <div className={props.slideNav ? "confResNavCntnr sideIn" : "confResNavCntnr"}>
            <div className="confResNavList">
                <div className="confResNavHdr">
                    <div className="confResNavRow">
                        <div className="confResNavActn" onClick={props.slideOut}></div>
                    </div>
                </div>
                <div className="confResNavBody">
                    <ul className="confNavGroup">
                        {props.role === "D" ? (
                            <Fragment>
                                <li className="confNavItem pointer" onClick={props.openPatientSlide}>
                                    <img src="/images/icons/medical-reports-outline.png" alt="icon" className="confNavIcon invertGray" />
                                    <span>{l.pat_details}</span>
                                </li>
                                <li className="confNavItem pointer" onClick={props.openSlide}>
                                    <img src="/images/icons/prescription-outline.png" alt="icon" className="confNavIcon invertGray" />
                                    <span>{l.presc}</span>
                                </li>
                                <li className="confNavItem pointer" onClick={props.openinternalNotes}>
                                    <img src="/images/icons/notes.png" alt="icon" className="confNavIcon invertGray" />
                                    <span>internalNote</span>
                                </li>
                                <li className="confNavItem pointer" onClick={props.openPatientHistory}>
                                    <img src="/images/icons/history.png" alt="icon" className="confNavIcon invertGray" />
                                    <span>Patient History</span>
                                </li>
                                <li className="confNavItem" onClick={props.handleScreenShare}>
                            <img src="/images/icons/screen-share.png" alt="icon" className="confNavIcon invertGray" />
                            <span>{l.screen_share}</span>
                        </li>
                                <li className="confNavItem pointer" onClick={props.handleWhiteBoard}>
                                    <img src="/images/icons/whiteboard-outline.png" alt="icon" className="confNavIcon invertGray" />
                                    <span>{l.whiteboard}</span>
                                </li>
                                {/* <li className="confNavItem" onClick={props.handleChatSlide}>
                                <img src="/images/icons/group-chat.png" alt="icon" className="confNavIcon invertGray" />
                                <span>{l.chat}</span>
                            </li> */}
                                <li className="confNavItem pointer" onClick={props.openConfInvite}>
                                    <img src="/images/icons/invite.png" alt="icon" className="confNavIcon invertGray" />
                                    <span>{l.invite}</span>
                                </li>
                                {/* {props?.appointmentData?.clinicData?.cloudRecordings && <li className="confNavItem pointer" onClick="">
                                    <img src="/images/cloudRecording.svg" alt="icon" className="confNavIcon invertGray" />
                                    <span>Cloud Recording</span>
                                </li>} */}
                                {props?.appointmentData?.clinicData?.cloudRecordings && <li className="confNavItem pointer" 
                                    onClick={record.cloudRecording ? ()=>record.stopCloudRecording() : ()=>record.startCloudRecording()}
                                >
                                    <img 
                                        src={record.cloudRecording ? "/images/cloudRecordingOff.svg" : "/images/cloudRecording.svg"}
                                        alt="icon" className="confNavIcon invertGray" />
                                    <span>{record.cloudRecording ? "Stop Cloud Recording" : "Start Cloud Recording"}</span>
                                </li>}
                                {props?.appointmentData?.clinicData?.localRecordings && <li className="confNavItem pointer" 
                                    onClick={record.localRecording ? ()=>record.stopRecording() : ()=>record.startLocalRecording()}
                                >
                                    <img 
                                        src={record.localRecording ? "/images/stopRecording.svg" : "/images/localRecording.svg"}
                                        alt="icon" className="confNavIcon invertGray" />
                                    <span>{record.localRecording ? "Stop Local Recording" : "Start Local Recording"}</span>
                                </li> }                               
                            </Fragment>
                        ) : (
                            <Fragment>
                                    <li className="confNavItem pointer" onClick={props.handleChatSlide}>
                                        <img src="/images/icons/group-chat.png" alt="icon" className="confNavIcon invertGray" />
                                        <span>{l.chat}</span>
                                    </li>
                                    <li className="confNavItem pointer" onClick={props.openPatientHistory}>
                                        <img src="/images/icons/history.png" alt="icon" className="confNavIcon invertGray" />
                                        <span>Patient History</span>
                                    </li>
                                    <li className="confNavItem pointer" onClick={props.openSlide}>
                                        <img src="/images/icons/prescription-outline.png" alt="icon" className="confNavIcon invertGray" />
                                        <span>{l.presc}</span>
                                    </li>
                                </Fragment>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ConfResNav;
